import axios from 'axios';

export function getErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const errorMessage = error.response?.data.message;
    if (errorMessage) {
      return errorMessage;
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  return `${error}`;
}

export function isNotFoundError(error: unknown): boolean {
  return (error as { response?: { status?: number } })?.response?.status === 404;
}
